import { FC } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslate } from 'hooks/useTranslate';

import Slider from 'modules/auth/components/Slider';
import { getLoginByCorporateId } from 'modules/auth/utils/getLoginByCorporateId';

import 'assets/styles/Pages.scss';
import 'assets/styles/Styles.scss';

import LoginFooter from './LoginFooter';
import LoginHeader from './LoginHeader';
import LoginWarning from './LoginWarning';

type LoginProps = {
  blockedMode?: boolean;
  customStyle: {
    societyName: string;
    pageStyle: string;
    button: {
      icon: string;
      text: string;
    };
    warning: {
      text: string;
      email: string;
    };
    logo: string;
    accessTitle: string;
    accessText: string;
  };
};

const Login: FC<LoginProps> = ({ blockedMode, customStyle }) => {
  const { t } = useTranslate();
  const { loginWithRedirect } = useAuth0();

  const { pageStyle, button, warning } = customStyle || getLoginByCorporateId();

  return (
    <div className={`nk-split nk-split-page nk-split-md ${pageStyle}`}>
      <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
        <div className="nk-block nk-block-middle nk-auth-body">
          <LoginHeader blockedMode={blockedMode} customStyle={customStyle} />

          {!blockedMode && (
            <button
              className="btn btn-lg btn-primary btn-block btn-login"
              type="button"
              aria-label="Login"
              onClick={() => loginWithRedirect()}
            >
              <em className={`icon ni mr-1 ${button?.icon}`} />
              {t(button?.text || 'Login')}
            </button>
          )}

          <LoginWarning warning={warning} />
        </div>

        <LoginFooter customStyle={customStyle} />
      </div>
      <Slider />
    </div>
  );
};

export default Login;
